// fileStorageService.js
import {ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import {customAttachmentStorage as storage} from "../auth/firebase.js";
/**
 * Firebase Storage service for handling file uploads, deletions, and URLs.
 */
export const fileStorageService = {
  
  /** Upload a single file and return its download URL */
  uploadFile: async (file, path) => {
    if (!file) return null;
    try {
      const fileRef = ref(storage, path);
      await uploadBytes(fileRef, file);
      const url = await getDownloadURL(fileRef);
      return { url, path };
    } catch (error) {
      throw error;
    }
  },

  /** Upload multiple files and return an array of { url, path } */
  uploadFiles: async (files, pathPrefix) => {
    if (!files || files.length === 0) return [];
    try {
      const uploadPromises = files.map((file, idx) => {
        const filePath = `${pathPrefix}/${idx}_${file.name}`;
        return fileStorageService.uploadFile(file, filePath);
      });
      return await Promise.all(uploadPromises);
    } catch (error) {
      throw error;
    }
  },

  /** Delete a single file using its storage path */
  deleteFile: async (filePath) => {
    if (!filePath) return;
    try {
      const fileRef = ref(storage, filePath);
      await deleteObject(fileRef);
    } catch (error) {
      // It's okay if file doesn't exist, just log it
    }
  },

  /** Delete multiple files given an array of storage paths */
  deleteFiles: async (filePaths) => {
    if (!filePaths || filePaths.length === 0) return;
    try {
      const deletePromises = filePaths.map(path => fileStorageService.deleteFile(path));
      await Promise.all(deletePromises);
    } catch (error) {
    }
  },

  /** Get download URL for a file stored in Firebase */
  getFileUrl: async (filePath) => {
    if (!filePath) return null;
    try {
      const fileRef = ref(storage, filePath);
      const url = await getDownloadURL(fileRef);
      return url;
    } catch (error) {
      return null;
    }
  },

  /** Generate download URLs for multiple files */
  getFilesUrls: async (filePaths) => {
    if (!filePaths || filePaths.length === 0) return [];
    try {
      const urlPromises = filePaths.map(path => fileStorageService.getFileUrl(path));
      return await Promise.all(urlPromises);
    } catch (error) {
      return [];
    }
  }
};
